export const SIGN_UP = 'SIGN_UP';
export const VERIFY_ACCOUNT = 'VERIFY_ACCOUNT';
export const UPDATE_ACCOUNT_STATUS = 'UPDATE_ACCOUNT_STATUS';
export const UPDATE_SIGN_UP_STATUS = 'UPDATE_SIGN_UP_STATUS';